/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useAuthContext, InitContextProps } from "services/context/authentication.context";
import CustomerCardService from "services/customer-card.service";
import { CustomerCardActivateResult } from "models/customer-card";
import { Spinner } from "react-bootstrap";
import { toast } from "react-toastify";

interface CustomerCardActivateContentProps {
  signingSessionId: string;
  cardNumbers: string[];
  onSuccess: () => void;
  handleModalHide: () => void;
}

export default function CustomerCardActivateContent({ signingSessionId, cardNumbers, onSuccess, handleModalHide }: CustomerCardActivateContentProps) {
  const { state }: InitContextProps = useAuthContext();
  const { customerId } = state;

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [result, setResult] = useState<CustomerCardActivateResult | null>();

  useEffect(() => {
    if (!customerId) return;

    const execute = async () => {
      try {
        const res = await CustomerCardService.activateCards(customerId, signingSessionId, cardNumbers, state.customer!.contactId);
        setResult(res);

        if (res.succeeded.length > 0) {
            onSuccess();
        } 

        if (res.failed.length === 0) {
          toast.success(`${res.succeeded.length > 1 ? 'Kaartide' : 'Kaardi'} aktiveerimine õnnestus`)
          handleModalHide();
        }

        if (res.succeeded.length === 0) {
          toast.error(`${res.failed.length > 1 ? 'Kaartide' : 'Kaardi'} aktiveerimine ebaõnnestus`)
          handleModalHide();
        }

      } catch (e) {
        console.error(e);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    execute();
  }, [customerId, signingSessionId]);

  if (loading) {
    return (
      <div className="p-4 d-flex justify-content-center">
        <Spinner animation="border" />
      </div>
    );
  }

  if (error) {
    return <div className="text-danger text-center p-3">Kaartide aktiveerimine ebaõnnestus</div>;
  }

  if (result) {
    return (
      <div className="text-center p-3">
        {result.succeeded.length > 0 && (
          <p>
            {result.succeeded.length === 1 ? "Kaart" : "Kaardid"} aktiveeritud: {result.succeeded.join(', ')}
          </p>
        )}
        {result.failed.length > 0 && (
          <p className="text-danger">
            Aktiveerimine ebaõnnestus: {result.failed.join(', ')}
          </p>
        )}
      </div>
    );
  }

  return null;
}
